import React from "react";
import styles from './IconCircle.module.css';

const IconCircle = ({icon, 
  style = {}, 
  containerStyle = {} }) => {
  return (
    <div className={styles.iconContainer} 
      style={containerStyle}>
        <div className={styles.iconCircle} 
        style={style}>
          {icon}
        </div>
      </div>
  );
}

export default IconCircle;